export default "__VITE_ASSET__DHCzdIJC__"